export default __webpack_public_path__ + "static/media/vecf-logo.da1f9608.png";